import AddEntry from "../components/AddEntry";

export default function AddPage() {
  return (
    <div className="max-w-2xl mx-auto px-4 py-8">
      <AddEntry />
    </div>
  );
}